import api from "../../api/services/axiosService";
import { MY_TATVA } from "../../envConstants";
import { getDecryptedData, getEncryptedText } from "../../utils/cryptoHelper";

const baseUrl: any = {
  customBaseUrl: MY_TATVA,
  isMyTatva: true,
  isTextPlain: true,
};

export const fetchMedicalConditions = async function () {
  let res = {
    data: "",
  };
  try {
    res = await api.post(
      `/api/v8/patient/medical_condition_group_list`,
      {},
      baseUrl
    );
    res.data = JSON.parse(getDecryptedData(res.data));
  } catch (e) {
    console.error("Error while fetching medical conditions: ", e);
  }
  return res.data;
};

export const fetchCarePlans = async function (payload: any) {
  let res = {
    data: "",
  };
  const encryptedPayload = getEncryptedText(payload);
  try {
    res = await api.post(
      `/api/v8/patient_plans/plan_by_condition`,
      encryptedPayload,
      baseUrl
    );
    res.data = JSON.parse(getDecryptedData(res.data));
  } catch (e) {
    console.error("Error while fetching care plans: ", e);
  }
  return res.data;
};

export const registerPatient = async function (payload: any) {
  let res = {
    data: "",
  };
  const encryptedPayload = getEncryptedText(payload);
  try {
    res = await api.post(`/api/v8/patient/register`, encryptedPayload, baseUrl);
    res.data = JSON.parse(getDecryptedData(res.data));
  } catch (e) {
    console.error("Error while registering patient: ", e);
  }
  return res.data;
};

export const referPlanToPatient = async function (payload: any) {
  let res = {
    data: "",
  };
  const encryptedPayload = getEncryptedText(payload);
  try {
    res = await api.post(
      `/api/v8/doctor/refer_plan_to_patient
    `,
      encryptedPayload,
      baseUrl
    );
    res.data = JSON.parse(getDecryptedData(res.data));
  } catch (e) {
    console.error("Error while referring plan to patient: ", e);
  }
  return res.data;
};

export const referredPlanDetails = async function (
  payload: any,
  page: number,
  per_page: number
) {
  let res = {
    data: "",
  };
  const encryptedPayload = getEncryptedText(payload);
  try {
    res = await api.post(
      `/api/v8/doctor/referred_plan_details?page=${page}&per_page=${per_page}`,
      encryptedPayload,
      baseUrl
    );
    res.data = JSON.parse(getDecryptedData(res.data));
  } catch (e) {
    console.error("Error while fetching referred plan details: ", e);
  }
  return res.data;
};

export const patientDetails = async function (payload: any) {
  let res = {
    data: "",
  };
  const encryptedPayload = getEncryptedText(payload);
  try {
    res = await api.post(
      `/api/v8/patient_plans/get_patient_plans
    `,
      encryptedPayload,
      baseUrl
    );
    res.data = JSON.parse(getDecryptedData(res.data));
  } catch (e) {
    console.error("Error while fetching patient details: ", e);
  }
  return res.data;
};
